export const ServiceAreasFields = {
  heading: {
    type: "custom",
    label: "Heading",
    metadata: {
      source: "ai",
      description: "Section heading for service areas (e.g. 'Areas We Serve')",
      seo: true,
      key: "serviceAreas.heading",
    },
  },
  subheading: {
    type: "custom",
    label: "Subheading",
    metadata: {
      source: "ai",
      description: "Brief introduction to service areas (15-20 words)",
      seo: false,
      key: "serviceAreas.subheading",
    },
  },
  layout: {
    type: "radio",
    label: "Layout",
    options: [
      { label: "Grid", value: "grid" },
      { label: "List", value: "list" },
      { label: "Compact Tags", value: "compact" },
    ],
    metadata: {
      source: "manual",
    },
  },
  showLinks: {
    type: "radio",
    label: "Show Links",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    metadata: {
      source: "manual",
      description: "Whether to link to individual location pages",
    },
  },
  showDescriptions: {
    type: "radio",
    label: "Show Descriptions",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    metadata: {
      source: "manual",
    },
  },
  baseUrl: {
    type: "text",
    label: "Base URL for Links",
    metadata: {
      source: "manual",
      description: "Base URL for generating area links (e.g., '/locations/')",
    },
  },
  areas: {
    type: "array",
    label: "Service Areas",
    metadata: {
      source: "data",
      description: "List of service areas/locations",
      key: "serviceAreas.list",
    },
    getItemSummary: (item: { displayName: string }) => item.displayName || "New Area",
    arrayFields: {
      name: {
        type: "text",
        label: "Name (slug)",
        metadata: {
          description: "URL-friendly name (e.g., 'austin')",
        },
      },
      displayName: {
        type: "text",
        label: "Display Name",
        metadata: {
          description: "Human-readable name (e.g., 'Austin, TX')",
        },
      },
      url: {
        type: "text",
        label: "Custom URL (optional)",
        metadata: {
          description: "Override the auto-generated URL",
        },
      },
      description: {
        type: "text",
        label: "Description (optional)",
        metadata: {
          description: "Brief description of this service area",
        },
      },
    },
    defaultItemProps: {
      name: "new-area",
      displayName: "New Area",
      url: "",
      description: "",
    },
  },
  showMap: {
    type: "radio",
    label: "Show Map",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    metadata: {
      source: "manual",
      description: "Whether to show an embedded Google Map above the area list",
    },
  },
  backgroundColor: {
    type: "text",
    label: "Background Color (optional)",
    metadata: {
      source: "manual",
    },
  },
} as const;
